<template>
    <div id="user-detail">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Tryout Members', to: { path: '/tryout-members' } },
                {
                    text: 'Daftar Tryout',
                    to: { path: '/tryout-members/' + $route.params.idgroup },
                },
                { text: 'Partisipan' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Partisipan</h3>

        <v-card>
            <v-data-table
                :headers="headers"
                :items="tryouts"
                :page.sync="pageNumber"
                hide-default-footer
                loading-text="Loading... Please wait"
            >
                <template v-slot:top>
                    <v-card-text>
                        <v-text-field
                            v-model="query"
                            @keyup.enter="loadDetailData(1)"
                            outlined
                            height="36px"
                            hide-details
                            small
                            dense
                            class="search_box"
                            placeholder="Ketik kata kunci dan tekan enter"
                        >
                            <template slot="prepend-inner">
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z"
                                        fill="#073554"
                                    />
                                    <path
                                        d="M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z"
                                        fill="#073554"
                                    />
                                </svg> </template
                        ></v-text-field>
                    </v-card-text>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <v-btn
                        elevation="0"
                        small
                        color="disabled"
                        class="black--text"
                        v-if="item.status === 'JOINED'"
                    >
                        BERGABUNG
                    </v-btn>
                    <v-btn
                        elevation="0"
                        small
                        color="backgroundYellow"
                        class="darkYellow--text"
                        v-if="item.status === 'STARTED'"
                    >
                        MENGERJAKAN
                        <span>({{ displayTimestamp(item.started_at) }})</span>
                    </v-btn>
                    <v-btn
                        elevation="0"
                        small
                        color="backgroundYellow"
                        class="darkYellow--text"
                        v-if="item.status === 'FINISHED'"
                    >
                        MENGUMPULKAN
                        <span>({{ displayTimestamp(item.completed_at) }})</span>
                    </v-btn>
                    <v-btn
                        elevation="0"
                        small
                        color="backgroundGreen"
                        class="darkGreen--text"
                        v-if="item.status === 'GRADED'"
                    >
                        DINILAI
                    </v-btn>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                        color="red"
                        text
                        :disabled="item.status === 'JOINED'"
                        @click="resetState(item.bundle_code, item.email)"
                    >
                        RESET
                    </v-btn>
                </template>
            </v-data-table>
            <div class="d-flex space-between pa-4">
                <span class="gray3--text">
                    Menampilkan {{ tryouts.length * pageNumber }} dari -
                </span>
                <v-spacer />
                <v-btn
                    depressed
                    class="pa-0"
                    :disabled="pageNumber == 1"
                    @click="loadDetailData(--pageNumber)"
                    min-width="32px"
                    height="32px"
                >
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                    class="pa-0 mx-2"
                    depressed
                    dark
                    color="blew"
                    min-width="32px"
                    height="32px"
                >
                    {{ pageNumber }}
                </v-btn>
                <v-btn
                    depressed
                    class="pa-0"
                    min-width="32px"
                    height="32px"
                    :disabled="tryouts.length < 10"
                    @click="loadDetailData(++pageNumber)"
                >
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import axios from "axios";
import DataTable from "@/modules/global/components/plugins/DataTable-s";
import moment from "moment";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "Tryout-members-detail",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            emailSIP: null,
            nomorIndukNF: null,
            isLoading: false,
            query: null,
            isLoading: false,
            pageNumber: 1,
            tryouts: [],
            headers: [
                { text: "Nama Peserta", value: "nama_peserta" },
                { text: "Pengerjaan (menit)", value: "completion_time" },
                { text: "Benar", value: "benar" },
                { text: "Salah", value: "salah" },
                { text: "Kosong", value: "kosong" },
                { text: "Status", value: "status" },
                { text: "Action", value: "action" },
            ],
        };
    },

    computed: {
        isActive: function () {
            var now = new moment();
            var expiredAt = new moment(
                this.$store.state.tryout.expired_at,
                "YYYY-MM-DD",
            );
            var diff = expiredAt.valueOf() - now.valueOf();

            return diff > 0;
        },
    },

    methods: {
        loadDetailData: function (page = 1) {
            var context = this;
            var token = this.$ls.get("token");
            var url =
                process.env.API_BASE_URL +
                "tryout-service/list_member_tryout?kode_tryout=" +
                this.$store.state.tryout.code;

            this.isLoading = true;
            var http = axios.create({
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });

            http.get(url, {
                params: {
                    page: this.pageNumber,
                    nama_peserta: this.query,
                },
            })
                .then(function (response) {
                    context.tryouts = response.data;
                    context.tryouts.forEach((element) => {
                        element.completion_time =
                            Number(element.completion_time) / 60;
                    });
                })
                .then(function () {
                    context.isLoading = false;
                });
        },

        displayTimestamp: function (timeInMilis) {
            if (!timeInMilis) return "-";
            return moment(timeInMilis).format("D MMM YYYY HH:mm");
        },

        getItemCount: function (tryout) {
            var total = 0;
            tryout.subtests.forEach(function (subtest) {
                total += subtest.item_count;
            });

            return total;
        },

        resetState: function (bundle_code, email) {
            if (
                confirm(
                    "apakah anda yakin mengembalikan status pengerjaan try out ini menjadi Bergabung?",
                )
            ) {
                var body = {
                    bundle_code: bundle_code,
                    email: email,
                };
                var context = this;
                TryoutService.resetStateTryout(body, function (result) {
                    if (result.success) {
                        context.tryouts = [];
                        context.loadDetailData();
                        alert("Reset Sukses!");
                    }
                });
            }
        },
    },

    mounted: function () {
        this.loadDetailData();
    },
};
</script>

<style scoped>
.search_box >>> .v-input__control {
    background: #fbfbfb !important;
    border: 1px solid rgba(230, 230, 230, 0.6) !important;
    border-radius: 8px !important;
}

.v-text-field--outlined >>> fieldset {
    border: 0 !important;
}

.search_box >>> .v-input__prepend-inner {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}

.v-data-table-header {
    color: #5c6275 !important;
    background: #f7f8fa !important;
}
</style>



// WEBPACK FOOTER //
// TryoutMembersDetail.vue?65d6e5f3